export default __webpack_public_path__ + "static/media/redMask.2c5f2eb9.svg";